import { httpsCallable } from "firebase/functions";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import { getFirebaseFunctions } from "../../../firebase";
import type { FactoringImageCreation } from "components/factoringModel";

interface Image {
  fileName: string;
  filePath: string;
  group: string;
}

interface Request {
  factoringId: string;
  images: Image[];
}

interface Response {
  success: boolean;
  message: string;
}

export const addFactoringImages = async (
  userId: string,
  factoringId: string,
  uploadFiles: File[],
) => {
  const functions = getFirebaseFunctions();
  const storage = getStorage();

  const addFactoringImagesFunction = httpsCallable<Request, Response, object>(
    functions,
    "addFactoringImages",
  );

  const group = Date.now().toString();

  const dirPrefix = `users/${userId}/factoring/${group}`;

  const uploadedImages: FactoringImageCreation[] = await Promise.all(
    uploadFiles.map(async (file, index) => {
      const filePath = `${dirPrefix}/${index}-${file.name}`;
      const storageRef = ref(storage, filePath);

      // ファイルをアップロード
      await uploadBytes(storageRef, file);

      return {
        fileName: file.name,
        filePath,
        group: group,
        entryId: "-1",
      };
    }),
  );

  const res = await addFactoringImagesFunction({
    factoringId,
    images: uploadedImages,
  });
  return res.data;
};
